import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

/**
 * Fetch all client QuickBooks mappings
 */
export const fetchClientQbMappings = createAsyncThunk(
  "clientQbMapping/fetchData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.TAB_MAPPING.GET_CLIENT_QB_MAPPING);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch client QB mappings"));
    }
  }
);
